// extracted by mini-css-extract-plugin
module.exports = {"locationGRDWrapper":"style_locationGRDWrapper__OXOeE"};